import { Record, List } from 'immutable';
import AssignedReader from './AssignedReader';
import UnassignedReader from './UnassignedReader';

const ReaderRecord = Record({
  assignedReaderResults: new List(),
  studentUnassignedReaderResults: new List(),
});

class Reader extends ReaderRecord { }

const reviver = ([key, item]) => {
  if (! item) return [key, item];
  switch (key) {
    case 'assignedReaderResults':
      return [key, new List(item.map((assignedReader) => AssignedReader.create(assignedReader)))];
    case 'studentUnassignedReaderResults':
      return [key, new List(item.map((unassignedReader) =>
        UnassignedReader.create(unassignedReader)))];
    default:
      return [key, item];
  }
};

Reader.create = (data) => new Reader(data).mapEntries(reviver);

export default Reader;



// WEBPACK FOOTER //
// ./data/Reader/model.js